import Entity from 'entities/entity';

interface EntityWithName {
  name?: string;
}

const multiplier = (reverse: boolean) => (reverse ? -1 : 1);

const compareStrings = (a: string, b: string) => compare((a || '').toLowerCase(), (b || '').toLowerCase());

const compare = (a: any, b: any) => {
  if (a === b) {
    return 0;
  }
  return a > b ? 1 : -1;
};

const name = (reverse = false) => (a: EntityWithName, b: EntityWithName) =>
  multiplier(reverse) * compareStrings(a.name, b.name);

const lastModified = (reverse = false) => (a: Entity, b: Entity) =>
  multiplier(reverse) * compare(a.audit.lastUpdatedAt, b.audit.lastUpdatedAt);

const lastCreated = (reverse = false) => (a: Entity, b: Entity) =>
  multiplier(reverse) * compare(a.audit.createdAt, b.audit.createdAt);

export const Sorters = {
  name,
  lastModified,
  lastCreated,
};
